import React, { useState, useEffect } from "react";
import "../../assets/css/argon-dashboard-react.css";
import { useNavigate } from "react-router-dom";
import "../../assets/css/LogIn.css";
import { loginUser, getCsrfToken, googleLogin, requestPasswordReset } from "../../apiHandles/user_authentication";
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';

import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;


const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const [csrfToken, setCsrfToken] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // Forgot Password States
  const [showForgotModal, setShowForgotModal] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");
  const [forgotLoading, setForgotLoading] = useState(false);
  const [forgotError, setForgotError] = useState("");
  const [forgotSuccess, setForgotSuccess] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  const screenHeight = window.innerHeight;

  const handleForgotPassword = async () => {
    try {
      setForgotLoading(true);
      setForgotError("");

      if (!forgotEmail) {
        setForgotError("Please enter your email address");
        setForgotLoading(false);
        return;
      }

      // Email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(forgotEmail)) {
        setForgotError("Please enter a valid email address");
        setForgotLoading(false);
        return;
      }

      // Call API
      const res = await requestPasswordReset(forgotEmail);

      if (res && (res.status === 200 || res.status === 201)) {
        setForgotSuccess(true);
        setForgotLoading(false);

        // Close modal after 3 seconds
        setTimeout(() => {
          setShowForgotModal(false);
          setForgotSuccess(false);
          setForgotEmail("");
        }, 3000);
      } else {
        setForgotError("Failed to send reset email. Please try again.");
        setForgotLoading(false);
      }

    } catch (err) {
      console.error("Forgot password error:", err);

      if (err.response?.status === 404) {
        setForgotError("Email address not found");
      } else if (err.response?.data?.message) {
        setForgotError(err.response.data.message);
      } else if (err.response?.data?.error) {
        setForgotError(err.response.data.error);
      } else {
        setForgotError("Failed to send reset email. Please try again.");
      }

      setForgotLoading(false);
    }
  };

  const handleGoogleSuccess = async (credentialResponse) => {
    try {
      setIsLoading(true);
      setError("");

      const res = await googleLogin(credentialResponse.credential);

      if (res && res.data && res.data.access) {
        localStorage.setItem("access", res.data.access);
        if (res.data.refresh) {
          localStorage.setItem("refresh", res.data.refresh);
        }
        if (res.data.username) {
          localStorage.setItem("username", res.data.username);
        }
        window.location.href = "/HomePage/homepage";
      } else {
        setIsLoading(false);
        setError("Google login failed");
      }
    } catch (err) {
      console.error("Google login error:", err);
      setError("Google login failed. Please try again.");
      setIsLoading(false);
    }
  };

  const handleGoogleError = () => {
    setError("Google login was unsuccessful. Please try again.");
  };

  const handleLogin = async () => {
    try {
      setIsLoading(true);
      setError("");

      if (!username || !password) {
        setError("Please enter both username and password");
        setIsLoading(false);
        return;
      }

      const res = await loginUser(username, password);

      if (res && res.data && res.data.access) {
        localStorage.setItem("access", res.data.access);
        if (res.data.refresh) {
          localStorage.setItem("refresh", res.data.refresh);
        }
        localStorage.setItem("username", username);
        setSuccess(true);
        window.location.href = "/HomePage/homepage";
      } else {
        setIsLoading(false);
        setError("Invalid response from server");
      }
    } catch (err) {
      console.error("Login error:", err);

      if (err.response?.data?.detail) {
        setError(err.response.data.detail);
      } else if (err.response?.data?.message) {
        setError(err.response.data.message);
      } else {
        setError("Login failed. Please try again.");
      }

      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!error) return;
    const timer = setTimeout(() => setError(""), 5000);
    return () => clearTimeout(timer);
  }, [error]);

  useEffect(() => {
    if (!forgotError) return;
    const timer = setTimeout(() => setForgotError(""), 5000);
    return () => clearTimeout(timer);
  }, [forgotError]);

  return (
    <div className="loginBack">
      <Col xs="12" sm="12" md="12" lg="12" xl="12" style={{ display: "flex", justifyContent: "center", width: "100%" }}>
        <Card className="loginCard">
          <CardHeader
            style={{
              background: "transparent",
              textAlign: "center",
              height: "210px",
            }}
          >
            <div style={{ marginBottom: "3%" }}>
              <p style={{
                color: "#d0d4daff",
                fontSize: "1rem",
                fontWeight: "400",
                paddinTop: "10px"
              }}>
                Welcome Back <br></br>Sign in to continue your journey
              </p>
            </div>

            <div style={{
              width: "100%",
              position: "relative"
            }}>
              <div
                className="google-login-container"
                style={{ borderRadius: "20px", width: "100%" }}
              >
                <GoogleLogin
                  onSuccess={handleGoogleSuccess}
                  onError={handleGoogleError}
                  useOneTap
                  size="large"
                />
              </div>
            </div>

            <div style={{ position: "relative", margin: "2rem 0" }}>
              <div
                style={{
                  position: "absolute",
                  inset: "0",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div style={{
                  width: "100%",
                  height: "1px",
                  background: "linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.6), transparent)"
                }}></div>
              </div>

              <div style={{
                position: "relative",
                display: "flex",
                justifyContent: "center"
              }}>
                <span className="loginCredentialText">
                  Or continue with credentials
                </span>
              </div>
            </div>
          </CardHeader>

          <CardBody>
            <Form role="form" onSubmit={e => { e.preventDefault(); handleLogin(); }}>
              <FormGroup >
                <label className="loginLabel">
                  Username / Email
                </label>

                <InputGroup
                  className="loginInputField"
                  onFocus={(e) => {
                    e.currentTarget.style.borderColor = "rgba(31, 91, 187, 0.6)";
                  }}
                  onBlur={(e) => {
                    e.currentTarget.style.borderColor = "rgba(71, 85, 105, 0.4)";
                    e.currentTarget.style.boxShadow = "none";
                    e.currentTarget.style.background = "rgba(51, 65, 85, 0.6)";
                  }}
                >
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText className="loginInputText">
                      <i className="ni ni-email-83" style={{ fontSize: "18px" }} />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    className="credentialTexts"
                    placeholder="Your username/email"
                    type="username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    autoComplete="username"
                    style={{
                      background: "transparent",
                      border: "none",
                      color: "white",
                      fontSize: "1rem",
                      padding: "16px 12px",
                      fontWeight: "500",
                      letterSpacing: "0.025em"
                    }}
                  />
                </InputGroup>
              </FormGroup>

              <FormGroup className="mb-4">
                <label className="loginLabel">
                  Password
                </label>
                <InputGroup
                  className="loginInputField"
                  onFocus={(e) => {
                    e.currentTarget.style.borderColor = "rgba(59, 130, 246, 0.6)";
                  }}
                  onBlur={(e) => {
                    e.currentTarget.style.borderColor = "rgba(71, 85, 105, 0.4)";
                    e.currentTarget.style.boxShadow = "none";
                    e.currentTarget.style.background = "rgba(51, 65, 85, 0.6)";
                  }}
                >
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText className="loginInputText">
                      <i className="ni ni-lock-circle-open" style={{ fontSize: "18px" }} />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="Your password"
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    autoComplete="current-password"
                    style={{
                      background: "transparent",
                      border: "none",
                      color: "white",
                      fontSize: "1rem",
                      padding: "16px 12px",
                      fontWeight: "500",
                      letterSpacing: "0.025em"
                    }}
                  />
                  <InputGroupAddon addonType="append">
                    <InputGroupText
                        className="loginInputText"
                        onClick={() => setShowPassword(prev => !prev)}
                        style={{ cursor: "pointer" }}
                    >
                      <i className={`fas ${showPassword ? "fa-eye-slash" : "fa-eye"}`} style={{ fontSize: "16px" }} />
                    </InputGroupText>
                </InputGroupAddon>
            </InputGroup>
              

                {error && (
                  <div className="loginErrorMsg">
                    <i className="ni ni-fat-remove" style={{ fontSize: "16px", flexShrink: 0 }}></i>
                    <span>{error}</span>
                  </div>
                )}
              </FormGroup>

              <div className="text-center">
                <Button
                  className="loginSignInbtn"
                  style={{
                    color: "#fff",
                    boxShadow: "none"
                  }}
                  type="submit"
                  disabled={isLoading}
                  onMouseOver={(e) => {
                    if (!isLoading) {
                      e.target.style.transform = "translateY(-1px)";
                      e.target.style.color = "white"
                    }
                  }}
                  onMouseOut={(e) => {
                    if (!isLoading) {
                      e.target.style.transform = "translateY(0px)";
                    }
                  }}
                >
                  {isLoading ? (
                    <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <div
                        style={{
                          width: "24px",
                          height: "24px",
                          border: "3px solid rgba(255, 255, 255, 0.3)",
                          borderTop: "3px solid white",
                          borderRadius: "50%",
                          animation: "spin 1s linear infinite",
                          marginRight: "12px",
                          color: "#fff"
                        }}
                      ></div>
                      Signing in...
                    </span>
                  ) : (
                    "Sign In"
                  )}
                </Button>
              </div>
            </Form>

            <div style={{ textAlign: "center", marginTop: "1vh" }}>
              <p className="DontHaveAccount" >
                Don't have an account?{" "}
                <a
                  href="#pablo"
                  onClick={() => navigate("/auth/register")}
                  className="loginCreateAccoutnbtn"
                  onMouseOver={(e) => {
                    e.target.style.transform = "translateY(-1px)";
                  }}
                  onMouseOut={(e) => {
                    e.target.style.transform = "translateY(0px)";
                  }}
                >
                  Create Account
                </a>
              </p>
            </div>

            <div style={{ textAlign: "center", marginTop: "0.5vh" }}>
              <button
                onClick={() => setShowForgotModal(true)}
                style={{
                  background: "none",
                  border: "none",
                  color: "#60a5fa",
                  fontSize: "0.9rem",
                  fontWeight: "500",
                  cursor: "pointer",
                  padding: "8px",
                  transition: "all 0.3s ease",
                  textDecoration: "none",
                }}
                onMouseOver={(e) => {
                  e.target.style.color = "#3b82f6";
                  e.target.style.textDecoration = "underline";
                }}
                onMouseOut={(e) => {
                  e.target.style.color = "#60a5fa";
                  e.target.style.textDecoration = "none";
                }}
              >
                Forgot password?
              </button>
            </div>
          </CardBody>
        </Card>
      </Col>

      <Row className="mt-4">
        <Col xs="12" sm="6" md="4" lg="3">
        </Col>
      </Row>

      {/* Forgot Password Modal */}
      <Modal
        isOpen={showForgotModal}
        toggle={() => !forgotLoading && setShowForgotModal(false)}
        centered
        style={{
          maxWidth: "500px",
        }}
      >
        <ModalHeader
          toggle={() => !forgotLoading && setShowForgotModal(false)}
          close={
            <button
              className="close"
              onClick={() => !forgotLoading && setShowForgotModal(false)}
              disabled={forgotLoading}
              style={{
                background: "transparent",
                border: "none",
                color: "white",
                fontSize: "1.5rem",
                fontWeight: "300",
                opacity: forgotLoading ? 0.5 : 0.7,
                cursor: forgotLoading ? "not-allowed" : "pointer",
                padding: "0.5rem",
                lineHeight: "1",
                transition: "opacity 0.2s",
              }}
              onMouseEnter={(e) => !forgotLoading && (e.target.style.opacity = "1")}
              onMouseLeave={(e) => !forgotLoading && (e.target.style.opacity = "0.7")}
            >
              ×
            </button>
          }
          style={{
            background: "linear-gradient(135deg, #1e293b 0%, #334155 100%)",
            color: "white",
            border: "none",
            borderBottom: "1px solid rgba(148, 163, 184, 0.2)",
          }}
        >
          <div style={{
            width: "100%",
            textAlign: "center",
            fontSize: "1.25rem",
            fontWeight: "600",
            marginLeft: "100%",
            color: "#fff"
          }}>
            Reset Password
          </div>
        </ModalHeader>

        <ModalBody style={{
          background: "linear-gradient(135deg, #1e293b 0%, #334155 100%)",
          padding: "2rem",
        }}>
          {!forgotSuccess ? (
            <>
              <Form
                id="forgot-password-form"
                onSubmit={(e) => {
                  e.preventDefault();
                  handleForgotPassword();
                }}
              >
                <p style={{ color: "#cbd5e1", fontSize: "0.95rem", marginBottom: "1.5rem" }}>
                  Enter your email address and we'll send you a link to reset your password.
                </p>

                <FormGroup>
                  <label style={{
                    color: "#e2e8f0",
                    fontSize: "0.9rem",
                    fontWeight: "600",
                    marginBottom: "0.5rem",
                    display: "block"
                  }}>
                    Email Address
                  </label>
                  <InputGroup
                    style={{
                      background: "rgba(51, 65, 85, 0.6)",
                      borderRadius: "12px",
                      border: "1px solid rgba(71, 85, 105, 0.4)",
                      overflow: "hidden",
                      transition: "all 0.3s ease",
                    }}
                    onFocus={(e) => {
                      e.currentTarget.style.borderColor = "rgba(59, 130, 246, 0.6)";
                      e.currentTarget.style.boxShadow = "0 0 0 3px rgba(59, 130, 246, 0.1)";
                    }}
                    onBlur={(e) => {
                      e.currentTarget.style.borderColor = "rgba(71, 85, 105, 0.4)";
                      e.currentTarget.style.boxShadow = "none";
                    }}
                  >
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText style={{
                        background: "transparent",
                        border: "none",
                        color: "#94a3b8",
                      }}>
                        <i className="ni ni-email-83" style={{ fontSize: "18px" }} />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="your.email@example.com"
                      type="email"
                      value={forgotEmail}
                      onChange={(e) => setForgotEmail(e.target.value)}
                      disabled={forgotLoading}
                      style={{
                        background: "transparent",
                        border: "none",
                        color: "white",
                        fontSize: "1rem",
                        padding: "14px 12px",
                      }}
                    />
                  </InputGroup>

                  {forgotError && (
                    <div style={{
                      marginTop: "0.75rem",
                      padding: "12px 16px",
                      background: "rgba(239, 68, 68, 0.1)",
                      border: "1px solid rgba(239, 68, 68, 0.3)",
                      borderRadius: "8px",
                      color: "#fca5a5",
                      fontSize: "0.875rem",
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      animation: "slideIn 0.3s ease-out"
                    }}>
                      <i className="ni ni-fat-remove" style={{ fontSize: "16px", flexShrink: 0 }}></i>
                      <span>{forgotError}</span>
                    </div>
                  )}
                </FormGroup>
              </Form>
            </>

          ) : (
            <div style={{
              textAlign: "center",
              padding: "2rem 1rem",
            }}>
              <div style={{
                width: "80px",
                height: "80px",
                background: "rgba(34, 197, 94, 0.1)",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 1.5rem",
                border: "3px solid rgba(34, 197, 94, 0.3)",
              }}>
                <i className="ni ni-check-bold" style={{
                  fontSize: "40px",
                  color: "#22c55e",
                }}></i>
              </div>
              <h3 style={{
                color: "white",
                fontSize: "1.5rem",
                fontWeight: "600",
                marginBottom: "1rem",
              }}>
                Check Your Email
              </h3>
              <p style={{
                color: "#cbd5e1",
                fontSize: "0.95rem",
                lineHeight: "1.6",
              }}>
                We've sent a password reset link to <strong style={{ color: "#60a5fa" }}>{forgotEmail}</strong>
              </p>
              <p style={{
                color: "#94a3b8",
                fontSize: "0.875rem",
                marginTop: "1rem",
              }}>
                Please check your inbox and follow the instructions.
              </p>
            </div>
          )}
        </ModalBody>

        {!forgotSuccess && (
          <ModalFooter style={{
            background: "linear-gradient(135deg, #1e293b 0%, #334155 100%)",
            border: "none",
            borderTop: "1px solid rgba(148, 163, 184, 0.2)",
            padding: "1.25rem 2rem",
            gap: "12px",
          }}>
            <Button
              onClick={() => {
                setShowForgotModal(false);
                setForgotEmail("");
                setForgotError("");
              }}
              disabled={forgotLoading}
              style={{
                background: "rgba(71, 85, 105, 0.4)",
                border: "1px solid rgba(71, 85, 105, 0.6)",
                color: "#cbd5e1",
                padding: "12px 24px",
                borderRadius: "10px",
                fontWeight: "600",
                fontSize: "0.95rem",
                transition: "all 0.3s ease",
              }}
              onMouseOver={(e) => {
                if (!forgotLoading) {
                  e.target.style.background = "rgba(71, 85, 105, 0.6)";
                  e.target.style.color = "white";
                }
              }}
              onMouseOut={(e) => {
                if (!forgotLoading) {
                  e.target.style.background = "rgba(71, 85, 105, 0.4)";
                  e.target.style.color = "#cbd5e1";
                }
              }}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              form="forgot-password-form"
              disabled={forgotLoading || !forgotEmail}
              style={{
                background: forgotLoading || !forgotEmail
                  ? "rgba(59, 130, 246, 0.4)"
                  : "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
                border: "none",
                color: "white",
                padding: "12px 32px",
                borderRadius: "10px",
                fontWeight: "600",
                fontSize: "0.95rem",
                transition: "all 0.3s ease",
                boxShadow: forgotLoading || !forgotEmail
                  ? "none"
                  : "0 4px 12px rgba(59, 130, 246, 0.3)",
              }}
              onMouseOver={(e) => {
                if (!forgotLoading && forgotEmail) {
                  e.target.style.transform = "translateY(-2px)";
                  e.target.style.boxShadow = "0 6px 16px rgba(59, 130, 246, 0.4)";
                }
              }}
              onMouseOut={(e) => {
                if (!forgotLoading && forgotEmail) {
                  e.target.style.transform = "translateY(0)";
                  e.target.style.boxShadow = "0 4px 12px rgba(59, 130, 246, 0.3)";
                }
              }}
            >
              {forgotLoading ? (
                <span style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "12px" }}>
                  <div style={{
                    width: "20px",
                    height: "20px",
                    border: "3px solid rgba(255, 255, 255, 0.3)",
                    borderTop: "3px solid white",
                    borderRadius: "50%",
                    animation: "spin 1s linear infinite",
                  }}></div>
                  Sending...
                </span>
              ) : (
                "Send Reset Link"
              )}
            </Button>
          </ModalFooter>
        )}
      </Modal>
    </div>
  );
};

const LoginWithProvider = () => {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <Login />
    </GoogleOAuthProvider>
  );
};

export default LoginWithProvider;